export const ventilationLevels = [
  {
    key: 1,
    value: 'Ambiente fechado, com muitas paredes, poucas janelas ou aberturas, onde o ar circula pouco e tem dificuldade para se renovar.'
  },
  {
    key: 2,
    value: 'Ambiente fechado, com muitas paredes, mas com janelas, portas, aberturas ou equipamentos que ajudam na circulação do ar.'
  },
  {
    key: 3,
    value: 'Ambiente aberto ou quase aberto, com poucas paredes ou barreiras, onde o ar circula livremente de forma natural.'
  }
]
